import React, { useCallback } from "react";
import moment from "moment-timezone";

import { DataInAnyRow } from "components/PageDashboard/ExternalCommitmentsSection/ExternalCommitmentsTable/ExternalCommitmentsTable";
import { ModalWizardStepRenderProps } from "components/ModalWizard/ModalWizard";
import { getDateFromSelection } from "components/FieldDate/FieldDateSelection";
import StepTime from "components/PageDashboard/StepTime";

function StepTimeFrom({
	wizardData,
	...rest
}: ModalWizardStepRenderProps<DataInAnyRow>) {
	const {
		dateStartsInRowTimezone,
		dateEndsJustBeforeInRowTimezone,
		timeEndsJustBeforeInRowTimezone,
		timezone
	} = wizardData;

	const checkDisabled = useCallback(
		(time: number) => {
			if (dateStartsInRowTimezone === undefined) {
				return false;
			}

			if (timezone === undefined) {
				return false;
			}

			const thisDateTime = moment(
				getDateFromSelection(
					{ ...dateStartsInRowTimezone, hours: time },
					timezone
				)
			);

			const currentHour = moment()
				.tz(timezone)
				.startOf("hour");

			if (thisDateTime.isSameOrBefore(currentHour)) {
				return true;
			}

			if (dateEndsJustBeforeInRowTimezone === undefined) {
				return false;
			}
			if (timeEndsJustBeforeInRowTimezone === undefined) {
				return false;
			}

			const dateTimeEndsJustBefore = moment(
				getDateFromSelection(
					{
						...dateEndsJustBeforeInRowTimezone,
						hours: timeEndsJustBeforeInRowTimezone.hours()
					},
					timezone
				)
			);

			return thisDateTime.isSameOrAfter(dateTimeEndsJustBefore);
		},
		[
			dateStartsInRowTimezone,
			dateEndsJustBeforeInRowTimezone,
			timeEndsJustBeforeInRowTimezone,
			timezone
		]
	);

	return (
		<StepTime
			wizardData={wizardData}
			wizardKey="timeStartsInRowTimezone"
			checkDisabled={checkDisabled}
			{...rest}
		/>
	);
}

export default StepTimeFrom;
